import { render, staticRenderFns } from "./BulkAllocationDialog.vue?vue&type=template&id=33690971&"
import script from "./BulkAllocationDialog.vue?vue&type=script&lang=js&"
export * from "./BulkAllocationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports